import React from 'react'
import { Text, Box } from '@deseretbook/react-ui'
import Address from './Address'
import { withCheckout } from './CheckoutContext'

const DeliveryStepSummary = ({ order }) => {
  const { shipments } = order

  return shipments
    .map(({
      shippingRates, shippingMethods, id, retailStore,
    }) => {
      const selected = shippingRates.filter(({ selected }) => selected)[0]
      const method = selected && shippingMethods
        .filter(({ id }) => id === selected.shippingMethodId)[0]

      if (!method) {
        return null
      }

      const isStorePickup = retailStore && method && method.adminName === 'Store Pickup'

      return (
        <Box key={id} paddingBottom={0.5}>
          <Text hasEllipsis isBold>{method.name}</Text>
          {
            isStorePickup
              ? <React.Fragment>
                  <Address address={retailStore} />
                  <Text>{retailStore.shippingTime}</Text>
                </React.Fragment>
              : null
          }
        </Box>
      )
    })
}

export default withCheckout(DeliveryStepSummary)
